import { render, staticRenderFns } from "./GaugeModule.vue?vue&type=template&id=630f586a&scoped=true"
import script from "./GaugeModule.vue?vue&type=script&lang=js"
export * from "./GaugeModule.vue?vue&type=script&lang=js"
import style0 from "./GaugeModule.vue?vue&type=style&index=0&id=630f586a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630f586a",
  null
  
)

export default component.exports